import { OrderType } from '@core/types/order-type.type';

export class OrderTypeAction {
  static readonly type = '[OrderType]';
  constructor(public orderType: OrderType) {}
}
